var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 0.999563C13.1215 1.45423 13.0003 1.96294 13 2.49994L2.75 2.50027C2.05964 2.50027 1.5 3.05991 1.5 3.75027V16.2503C1.5 16.9406 2.05964 17.5003 2.75 17.5003H15.25C15.9404 17.5003 16.5 16.9406 16.5 16.2503V6.00195C17.0372 6.00195 17.5461 5.88092 18.001 5.66464L18 16.2503C18 17.7691 16.7688 19.0003 15.25 19.0003H2.75C1.23122 19.0003 0 17.7691 0 16.2503V3.75027C0 2.23149 1.23122 1.00027 2.75 1.00027L13.338 0.999563ZM16.5 0.00195312C17.8807 0.00195312 19 1.12124 19 2.50195C19 3.88266 17.8807 5.00195 16.5 5.00195C15.1193 5.00195 14 3.88266 14 2.50195C14 1.12124 15.1193 0.00195312 16.5 0.00195312Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScope);
export default __webpack_public_path__ + "static/media/scope.dd5367964e6f1c95f7a5da1783ab1d3b.svg";
export { ForwardRef as ReactComponent };